/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import store from './store';
import router from './router';

const bugsnagClient = bugsnag({
    apiKey: '8cf215dcb894a6817c28b8abeb7476e6',
    notifyReleaseStages: ['production'],
    releaseStage: process.env.NODE_ENV,
});
bugsnagClient.use(bugsnagVue, Vue);

Vue.component('highcharts', require('./components/Highcharts.vue').default);
Vue.component('analyze', require('./components/Analyze.vue').default);
Vue.component('modify', require('./components/Modify.vue').default);
Vue.component('modal', require('./components/Modal.vue').default);
Vue.component('time-slider', require('./components/TimeSlider.vue').default);
Vue.component('analyze-series', require('./components/AnalyzeSeries.vue').default);
Vue.component('headline', require('./components/Headline.vue').default);
Vue.component('regression', require('./components/Regression.vue').default);
Vue.component('regression-series', require('./components/RegressionSeries.vue').default);
Vue.component('loading', require('./components/Loading.vue').default);
Vue.component('exporter', require('./components/Exporter.vue').default);
Vue.component('time-series', require('./components/TimeSeries.vue').default);
Vue.component('periodicity', require('./components/Periodicity').default);
Vue.component('add-series', require('./components/AddSeries').default);
Vue.component('history', require('./components/History').default);
Vue.component('load-file', require('./components/LoadFile').default);
Vue.component('save', require('./components/Save.vue').default);
Vue.component('visibility', require('./components/Visibility.vue').default);
Vue.component('autocomplete', require('../components/search/autocomplete.vue').default);
Vue.component('series', require('./spa/Series.vue').default);
Vue.component('colors', require("./components/Colors").default);
Vue.component('export-image', require("./components/ExportImage").default);
Vue.component('error-response', require("./components/ErrorResponse").default);

Vue.component('checklist', require('../components/Checklist').default);
Vue.component('nav-bar', require('./components/NavBar').default);

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his childrens
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

new Vue({

    store,

    data: () => ({
        state: dashboard.state,
    }),

    created() {
        this.$store.dispatch('getData', this.state.id);
    },

    router,

}).$mount('#vue');
